module.exports = __webpack_public_path__ + "static/media/uk_flag.515f5bcd.svg";